module.exports = __webpack_public_path__ + "img/art-32.57ddb7d9.png";